import React, { useState, useEffect } from "react";
import { Input, InputBase } from "@mui/material";

export default function TableTestForm (props) {
    
    const [tableCols, setTableCols]=useState(props.tableColumns);

    const [tableData, setTableData]=useState(props.tableDataP);
    console.log("ABC=" + tableData);
    
    const [tableDataD, setTableDataD] = useState([]);
    const [tableDataDCopy, setTableDataDCopy] = useState([]);
    
    let APIURL="myapi/ulccv";
    
    function loadData(dataFrom){
        setTableDataDCopy(dataFrom);
        
        console.log("QWE=" + dataFrom);
        console.log("QWE setTableDataDCopy=" + tableDataDCopy);
        
        setTableDataD(dataFrom);
        
    }
    
    useEffect(()=>{
    
    fetch(APIURL)
    .then(response=> response.json())
    .then(json=> loadData(json))
    
    .finally(()=>{

    })
    }, [])
    

    const [searchText , setSearchText ]=useState('');
    function handleSearchOnChange(event){
        
        setSearchText(event.target.value);
    }

    useEffect(()=>{
        
        //let oldData=tableDataD;
        //if(searchText==""){
           // setTableDataD(tableDataDCopy);
        //}
        //else{
            //let newData=[];
            console.log("tableDataDCopy=" + tableDataDCopy)
            let newData=tableDataDCopy.filter(tableDataDCopy => tableDataDCopy.username.toLowerCase().includes(searchText.toLowerCase()))
            console.log("newData=" + newData)
            setTableDataD(newData);
        //}
        

    }, [searchText])

    

    return(
        <div>
             
             <Input placeholder="Search" onChange={handleSearchOnChange} />
             
            <br/>
        <table>
            <thead>
                <tr>
                    {
             tableCols.map( function (tc){
                   return (
                    <th key={tc.id}
                    sx={{
                        width:tc.width
                    }}
                    >
                        {tc.title}
                    </th>
                  )
                }
             )
             }
             </tr>
            </thead>
            
            <tfoot>
            <tr>
                    {
             tableCols.map( function (tc){
                   return (
                    <th key={tc.id} 
                    sx={{
                        width:tc.width
                    }}
                    >
                        {tc.title}
                    </th>
                  )
                }
             )
             }
             </tr>
            </tfoot>

            <tbody>
                   <tr>
                   <td  
                    style={{border: '1px solid white', padding: '2px'}}
                    >
                    123
                    </td>
                    <td
                    style={{border: '1px solid white', padding: '2px'}}
                    >345</td>
                    <td
                    style={{border: '1px solid white', padding: '2px'}}
                    >678</td>
                    <td
                    style={{border: '1px solid white', padding: '2px'}}
                    >987</td>
                    </tr>
               
             {
              tableDataD.map(function ({id, username, email, password, status}){
               return (
                <tr key={id}>
                    <td  
                    style={{border: '1px solid white', padding: '2px'}}
                    >
                    {username}
                    </td>
                    <td>{email}</td>
                    <td>{password}</td>
                    <td>{status}</td>
                </tr>
               );
              })
             }
            </tbody>

        </table>


        </div>
    )
}
